/**
 * Canonical residential trade taxonomy — TS mirror of schema/trade.py
 * (schema-review Slice 2, 2026-06-11).
 *
 * Keep in one-to-one correspondence with the Python enum and the Swift
 * mirror (ios/.../Models/Trade.swift); a change to one is a PR that
 * updates all three.
 *
 * `TradeLabel` is the display-string union the fixture seams render
 * today (subs / schedule crews). Typing fixture `trade` fields against
 * it makes cross-surface drift a compile error instead of a silent
 * string mismatch. `TRADE_VALUES` maps labels to the stable snake_case
 * wire identifiers for API io (Subs backend, QBO class mapping).
 */

export const TRADES = [
  // Lead / design roles first — the access-page audience picks what they are.
  { value: "general_contractor",  label: "General Contractor / Builder" },
  { value: "architecture",        label: "Architecture" },
  { value: "interior_design",     label: "Interior Design" },
  // Trades
  { value: "framing",             label: "Framing" },
  { value: "electrical",          label: "Electrical" },
  { value: "plumbing",            label: "Plumbing" },
  { value: "hvac",                label: "HVAC" },
  { value: "drywall",             label: "Drywall" },
  { value: "painting",            label: "Painting" },
  { value: "roofing",             label: "Roofing" },
  { value: "stone",               label: "Stone" },
  { value: "tile",                label: "Tile" },
  { value: "flooring",            label: "Flooring" },
  { value: "windows_doors",       label: "Windows & Doors" },
  { value: "cabinetry",           label: "Cabinetry" },
  { value: "finish_carpentry",    label: "Finish carpentry" },
  { value: "concrete_foundation", label: "Concrete & foundation" },
  { value: "masonry",             label: "Masonry" },
  { value: "insulation",          label: "Insulation" },
  { value: "siding_exterior",     label: "Siding & exterior" },
  { value: "excavation_sitework", label: "Excavation & sitework" },
  { value: "landscaping",         label: "Landscaping" },
  { value: "demolition",          label: "Demolition" },
  { value: "general_labor",       label: "General labor" },
  { value: "other",               label: "Other" },
] as const;

export type TradeValue = (typeof TRADES)[number]["value"];
export type TradeLabel = (typeof TRADES)[number]["label"];

export const TRADE_VALUE_BY_LABEL: Record<TradeLabel, TradeValue> =
  Object.fromEntries(TRADES.map((t) => [t.label, t.value])) as Record<TradeLabel, TradeValue>;

export const TRADE_LABEL_BY_VALUE: Record<TradeValue, TradeLabel> =
  Object.fromEntries(TRADES.map((t) => [t.value, t.label])) as Record<TradeValue, TradeLabel>;
